import InvoiceReasons from '~/components/shared/InvoiceReasons';
import React from 'react';
import {View, ScrollView} from 'react-native';
import sy from '~/styles';
import {
  Text,
  Dialog,
  FormTextInput,
  FormNumberInput,
} from '~/components/controls';
import {RobRequestErrorsDialog} from '~/components/shared/Dialogs';
import {ROB_ERROR_TRANSLATIONS} from '~/types/rob';
import AssignmentTurnedInIcon from '~/images/md-icons/assignment_turned_in/materialicons/24px.svg';
import ErrorIcon from '~/images/md-icons/error/materialicons/24px.svg';
const RequestDialogs = React.memo(
  ({
    showRequestDialog,
    requestTitle,
    RobReasonsDialog,
    is_fleet_car,
    is_retail_car,
    setShowRequestDialog,
    onRequest,
    partialVin,
    setPartialVin,
    partialVinError,
    setPartialVinError,
    current_mileage,
    setCurrentMileage,
    showRobReasonsDialog,
    overview,
    robComponents,
    setShowRobReasonsDialog,
    showNoInvoiceDialog,
    setShowNoInvoiceDialog,
    onChangeInvoiceStatus,
    setInvoiceStatus,
    invoiceStatus,
    showNoInvoiceInfoDialog,
    setShowNoInvoiceInfoDialog,
    showRobRequestErrorsDialog,
    robErrors,
    setShowRobRequestErrorsDialog,
    showRobTaskErrorsDialog,
    setShowRobTaskErrorsDialog,
  }) => (
    <>
      {showRequestDialog && (
        <Dialog
          visible={true}
          title={
            requestTitle ??
            (is_fleet_car || is_retail_car ? 'Aanvraag' : 'Aanvraag ROB')
          }
          onDismiss={() => setShowRequestDialog(false)}
          buttons={[
            {
              text: 'Annuleren',
              onPress: () => setShowRequestDialog(false),
            },
            {
              text: 'Verzenden',
              textStyle: {
                color: '#972727',
              },
              onPress: onRequest,
            },
          ]}>
          <View
            style={[
              {
                paddingTop: 24,
              },
              sy['gap-4'],
            ]}>
            <FormTextInput
              label="Meldcode"
              value={partialVin}
              hasError={partialVinError}
              errorMessage="Meldcode komt niet overeen met dit voertuig"
              onChangeText={(value) => {
                setPartialVinError?.(false);
                setPartialVin(value);
              }}
              inputProps={{
                maxLength: 4,
                keyboardType: 'numeric',
              }}
            />
            <FormNumberInput
              label="Huidige kilometerstand"
              value={current_mileage}
              digits={0}
              onChangeNumber={(value) => setCurrentMileage(value)}
              onSubmit={onRequest}
            />
          </View>
        </Dialog>
      )}

      {showRobReasonsDialog && (
        <RobReasonsDialog
          visible={true}
          component_id={showRobReasonsDialog.component_id}
          rob_code={showRobReasonsDialog.rob_code}
          tasks={overview.components.flatMap((c) => c.tasks ?? [])}
          rob={overview.rob}
          rob_components={robComponents}
          onDismiss={() => setShowRobReasonsDialog(null)}
        />
      )}

      {showNoInvoiceDialog && (
        <Dialog
          visible={true}
          title="Reden geen factuur"
          buttons={[
            {
              text: 'Annuleren',
              onPress: () => setShowNoInvoiceDialog(false),
            },
            {
              text: 'Opslaan',
              textStyle: {
                color: '#972727',
              },
              onPress: onChangeInvoiceStatus,
            },
          ]}
          options={{
            noPaddingContent: true,
          }}>
          <InvoiceReasons
            invoiceStatus={invoiceStatus}
            setInvoiceStatus={setInvoiceStatus}
          />
        </Dialog>
      )}

      {showNoInvoiceInfoDialog && (
        <Dialog
          visible={true}
          title="Gereed zonder factuur"
          buttons={[
            {
              text: 'OK',
              textStyle: {
                color: '#972727',
              },
              onPress: () => setShowNoInvoiceInfoDialog(false),
            },
          ]}>
          <View style={[sy['flex-row'], sy['py-4']]}>
            <View
              style={[
                {
                  flexShrink: 0,
                },
                sy['pr-4'],
              ]}>
              <AssignmentTurnedInIcon
                height="24px"
                width="24px"
                fill="#828282"
              />
            </View>
            <Text>
              Opdracht niet gefactureerd. Toch wel factureren? Dit is mogelijk
              tot aan archivering.
            </Text>
          </View>
        </Dialog>
      )}

      {showRobRequestErrorsDialog && (
        <RobRequestErrorsDialog
          robErrors={robErrors}
          onDismiss={() => setShowRobRequestErrorsDialog(false)}
        />
      )}

      {showRobTaskErrorsDialog && (
        <Dialog
          visible={true}
          title={showRobTaskErrorsDialog.title}
          buttons={[
            {
              text: 'OK',
              onPress: () => setShowRobTaskErrorsDialog(false),
            },
          ]}>
          <ScrollView
            contentContainerStyle={{
              maxHeight: 400,
            }}>
            {robErrors
              .filter(
                (item) =>
                  item.component_id === showRobTaskErrorsDialog.component_id,
              )
              .map((item, index) => (
                <View
                  style={[sy['flex-row'], sy['py-4']]}
                  key={item.id ?? `${item.code}-${index}`}>
                  <View
                    style={[
                      {
                        flexShrink: 0,
                      },
                      sy['pr-4'],
                    ]}>
                    <ErrorIcon height="24px" width="24px" fill="#972727" />
                  </View>
                  <View style={[sy['flex-1']]}>
                    <Text>
                      {ROB_ERROR_TRANSLATIONS[item.code] ?? item.error}
                    </Text>
                    <Text style={[sy.small, sy['text-lightgray']]}>
                      {item.code}
                    </Text>
                  </View>
                </View>
              ))}
          </ScrollView>
        </Dialog>
      )}
    </>
  ),
);
export default RequestDialogs;
